import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Field, GhostButton, PrimaryButton, inputCls } from "@/components/admin/parts";

export function ConfirmAction({ testid, icon: Icon, label, title, body, onConfirm, busy, danger }) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <GhostButton disabled={busy} className={`!py-2 ${danger ? "!text-red-400 hover:!border-red-500/60" : ""}`} data-testid={`${testid}-btn`}><Icon size={15} /> {label}</GhostButton>
      </AlertDialogTrigger>
      <AlertDialogContent className="bg-[#0F0F0F] border-neutral-800 text-neutral-100" data-testid={`${testid}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-neutral-400">{body}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-transparent border-neutral-700 text-neutral-200 hover:bg-white/5 hover:text-white" data-testid={`${testid}-cancel`}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className={danger ? "bg-red-500 hover:bg-red-600 text-white" : "bg-[#73bf44] hover:bg-[#5fa338] text-[#050505]"} data-testid={`${testid}-confirm`}>{label}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export function LabourSettings({ link, busy, onSave }) {
  const [rate, setRate] = useState("");
  const [mins, setMins] = useState("");
  const [parts, setParts] = useState("");
  useEffect(() => {
    setRate(String(link.hourly_labour_rate_aud ?? 45));
    setMins(String(link.manual_minutes_per_claim ?? 45));
    setParts(String(link.parts_minutes_per_order ?? 25));
  }, [link.hourly_labour_rate_aud, link.manual_minutes_per_claim, link.parts_minutes_per_order]);
  const save = () => {
    const r = Number(rate), m = Number(mins), p = Number(parts);
    if (!(r >= 1 && r <= 500)) return toast.error("Enter a labour rate between $1 and $500 an hour");
    if (!(Number.isInteger(m) && m >= 1 && m <= 600)) return toast.error("Enter whole minutes between 1 and 600");
    if (!(Number.isInteger(p) && p >= 0 && p <= 600)) return toast.error("Enter whole parts-order minutes between 0 and 600");
    onSave({ hourly_labour_rate_aud: r, manual_minutes_per_claim: m, parts_minutes_per_order: p });
  };
  return (
    <div className="border-t border-neutral-800 pt-4 space-y-3" data-testid="labour-settings">
      <div className="text-sm font-semibold text-white">Labour saved calculation</div>
      <div className="grid grid-cols-3 gap-3">
        <Field label="Labour rate ($ per hour)"><input type="number" step="0.01" min="1" value={rate} onChange={(e) => setRate(e.target.value)} className={inputCls} data-testid="labour-rate-input" /></Field>
        <Field label="Manual handling per claim (minutes)"><input type="number" step="1" min="1" value={mins} onChange={(e) => setMins(e.target.value)} className={inputCls} data-testid="manual-minutes-input" /></Field>
        <Field label="Extra when parts are ordered (minutes)"><input type="number" step="1" min="0" value={parts} onChange={(e) => setParts(e.target.value)} className={inputCls} data-testid="parts-minutes-input" /></Field>
      </div>
      <p className="text-xs text-neutral-500">Labour saved = (claims handled automatically × minutes + claims that needed parts × parts minutes) ÷ 60 × rate. Parts orders count from 4 Nov 2026. Only real automated actions count.</p>
      <PrimaryButton disabled={busy} onClick={save} className="!py-2" data-testid="labour-save-btn">Save</PrimaryButton>
    </div>
  );
}
